// 株式会社小林建設 不用品回収・遺品整理 LP 共通定数

export const COMPANY_NAME = "株式会社小林建設";
export const COMPANY_NAME_READ = "カブシキガイシャ コバヤシケンセツ";
export const SERVICE_NAME = "不用品回収・遺品整理";

export const POSTAL = "〒344-0021";
export const ADDRESS = "埼玉県春日部市大場207-1";
export const TEL_DISPLAY = "048-795-6298";
export const TEL_HREF = "tel:0487956298";
export const EMAIL = "kobayashikensetu@icloud.com";
export const EMAIL_HREF = "mailto:kobayashikensetu@icloud.com";
export const HOURS = "9:00〜18:00";
export const HOLIDAY = "年中無休（現場状況等により変動あり）";
export const FOUNDED = "2021年";

export const WEBSITE = "https://kobayashikensetu.jp/";
export const INSTAGRAM_URL = "https://www.instagram.com/kobayashikensetsu.kk/";
export const LINE_URL = "https://lin.ee/XmKUcd3";
export const LINE_QR = "https://qr-official.line.me/gs/M_811kjznc_GW.png?oat_content=qr";
export const GOOGLE_REVIEW_URL = "https://www.google.com/search?q=%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE%E5%B0%8F%E6%9E%97%E5%BB%BA%E8%A8%AD+%E6%98%A5%E6%97%A5%E9%83%A8%E5%B8%82+%E5%8F%A3%E3%82%B3%E3%83%9F";

export const FORM_ANCHOR = "#contact";
export const FORM_SUBMIT_URL = "https://readdy.ai/api/form/damm15lvmcl80jn293m0";
export const FORM_ID = "damm15lvmcl80jn293m0";

// イメージキャラクター「ぶたさん」（背景透過済み）
export const MASCOT_CERT =
  "https://public.readdy.ai/ai/img_res/3b23a078-22ce-4e00-834b-e8139043980a.png";
export const MASCOT_WORK =
  "https://public.readdy.ai/ai/img_res/e122de9a-8c87-45f3-a248-730af4e385e5.png";

// LINEブランドカラー（ブランド要素のため例外的に使用）
export const LINE_COLOR = "#06C755";

// ファーストビューのメインビジュアル
// 送っていただいた画像を加工せず、そのまま大きく表示する
export const HERO_MAIN_IMAGE = {
  src: "https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/79df38f4705736b1a6eea8d918583076.jpeg",
  alt: "不用品回収の箱を運ぶ、株式会社小林建設のぶたさんのキャラクター",
};

// 「片付けたあとの住まいも、相談できる会社に頼みたい」のメインビジュアル
// 送っていただいた画像を加工せず、そのまま大きく表示する
export const REFORM_MAIN_IMAGE = {
  src: "https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/c34db820b6f76a11c7f24f9dd1c63a45.jpeg",
  alt: "屋根の上のぶたさんと、屋根・外壁の修繕／内装リフォーム／片付け後の原状回復のご案内",
};

// お支払い方法
// 送っていただいたAirPAY画像をそのまま使用
export const PAYMENT_IMAGE = {
  src: "https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/4754df2aa9c72308433b4c8222810a6d.jpeg",
  alt: "お支払い方法（AirPAY：各種クレジットカード・交通系電子マネー・QRコード決済に対応）",
};